module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-25-march.json
// module id = 433
// module chunks = 35990112870198